var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-content"},[_c('div',{staticClass:"company-tree"},[_c('el-tree',{ref:"tree",staticClass:"filter-tree",attrs:{"data":_vm.treeData,"props":_vm.defaultProps,"expand-on-click-node":false,"highlight-current":true,"default-expand-all":true,"node-key":"id"},on:{"current-change":_vm.currentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }